import CardOverlay, { CardFooterContent } from './CardOverlay';
import { IconText } from './Amount';
import { useImages } from '../context/ImageContext';
import { IsMobile, useHover } from '../utils/Mobile';
const TerritoryEffects = require('@tta/engine/Constants/Territories/TerritoryEffects');
const { useRef } = require('react');
const { Card }  = require('react-bootstrap');
const { GetCardColor, WhiteOutline } = require('./Utilities/Utilities')

// onClick is only given for cards that can be taken (or put back) right now.
// ghost: a greyed-out copy left in the slot of a card taken this turn.
// blocked: why the current player cannot take this card; shown as a red border, with the reason on hover.
// A long name in the small body: smaller, so it fits and words are not split (e.g. "Transcontinental Railroad")
export const NameFit = (name = '') => {
    const longest = Math.max(...name.split(' ').map(word => word.length));
    const size = longest > 13 || name.length > 26 ? 9 : longest > 11 || name.length > 18 ? 10 : 11;
    return { fontSize: `${size}px`, lineHeight: `${size + 1}px`, overflowWrap: 'normal', wordBreak: 'normal', overflow: 'hidden' };
};

// What colonizing a territory gives at once (its card's payout), or null for any other card
const Payout = (card) => card.type === 'Territory' ? TerritoryEffects[card.name]?.payout?.(card) ?? null : null;

// A tiny portrait of whoever changed the card (e.g. Sun Tzu under a tactic), or its +N where there is no picture yet
const TinyPortrait = ({who, bonus}) => {
    const { images } = useImages();
    return <div className="tta-tiny-portrait" title={`${who.source}: +${bonus} per army`}>
        {images?.[who.image] ? <img src={images[who.image].src} alt={who.source}/> : `+${bonus}`}</div>;
};

// selected: picked for a choice, waiting to be confirmed (a dashed outline)
const RowCard = ({card, onClick, ghost = false, title, blocked, selected = false}) => {
    const { images } = useImages();
    const [showOverlay, setShowOverlay, hoverProps] = useHover();
    const componentRef = useRef(null);

    const cardColor = GetCardColor(card)

    const headerStyle = {
        height: '17px',
        padding: '0px',
        fontFamily: 'Stencil, Times New Roman, Serif',
        textShadow: WhiteOutline,
        fontSize: '11px',
        textAlign: 'center',
    }

    const cardStyle = {
        backgroundColor: cardColor,
        padding: 0,
        width: '80px',
        height: '77px',
        position: 'relative',
        boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.5)'
    }

    const bodyStyle = {
        backgroundColor: '#fdf9dc',
        height: '42px',
        padding: 3,
        fontFamily: 'Arial, Helvetica, Sans-Serif',
        fontSize: '11px',
    }

    const footerStyle = {
        height: '16px',
        padding: '3px',
        textAlign:'center',
        // (as on the hover: readable on the dark colors)
        textShadow: WhiteOutline,
    }

    if (card === null || card === undefined )
    {
        return (
            <Card border="light" style={cardStyle}>
                <Card.Header style = {headerStyle}/>
                <Card.Body style={bodyStyle}></Card.Body>
                <Card.Footer/>
            </Card>
        )
    }

    return (
        <div>
            <Card 
                border="0px"
                padding="5px"
                style={{...cardStyle, cursor: onClick ? 'pointer' : 'default',
                    ...(ghost ? { opacity: 0.4, filter: 'grayscale(85%)', boxShadow: 'none' } : {}),
                    ...(blocked ? { outline: '2px solid #d0342c', outlineOffset: '-1px' } : {}),
                    ...(selected ? { outline: '2px dashed #1a73e8', outlineOffset: '2px' } : {})}}
                ref = {componentRef}
                onClick = {onClick}
                title = {title ?? blocked}
                {...hoverProps}
            >
                <Card.Header style = {headerStyle}>{card.age.slice(4)}</Card.Header>
                <Card.Body style={{ ...bodyStyle, ...NameFit(card.name) }}>{card.name}
                    {/* A territory: what colonizing it gives at once, under its name */}
                    {Payout(card) && <div className="tta-row-card-payout"><IconText text={Payout(card)}/></div>}
                    {/* A tactic Sun Tzu went under: a tiny him */}
                    {card.tacticBonusBy && <TinyPortrait who={card.tacticBonusBy} bonus={card.tacticBonus}/>}</Card.Body>
                {/* (a territory: what it gives while held, along the bottom as printed) */}
                <Card.Footer style={footerStyle} className="tta-row-card-footer">{card.type === 'Territory' && <CardFooterContent card={card} images={images}/>}</Card.Footer>
            </Card>
            <CardOverlay
                ShowOverlay={showOverlay}
                ComponentRef={componentRef}
                card={card}
                callback={setShowOverlay}
                OnClose={() => setShowOverlay(false)}
                // (on a phone a tap shows the card: taking it, or putting it back, is done from there)
                Action={IsMobile && onClick ? { label: ghost ? 'Put back' : 'Take', onClick } : undefined}
                Note={title ?? blocked}
            />
        </div>
  );
};

export default RowCard;